import { FilterType } from '@placer-ui/types';
import { AUDIENCE_TYPE_DICT, DEFAULT_AUDIENCE } from 'shared/constants/audience-type';
import { DEFAULT_VISITS, MOBILE_VISITS_DURATION_TITLE_DICT } from 'shared/constants/visit-duration';

export const DEFAULT_FILTER_BY_TYPE: Partial<Record<FilterType, string>> = {
    visits_type: AUDIENCE_TYPE_DICT[DEFAULT_AUDIENCE],
    visit_duration: MOBILE_VISITS_DURATION_TITLE_DICT[DEFAULT_VISITS],
};
